export default function StatCard({ title, value, growth, color }) {
  const colors = {
    teal: "border-teal-400",
    blue: "border-blue-400",
    orange: "border-orange-400",
    red: "border-red-400"
  };

  return (
    <div className={`bg-white rounded-xl p-5 border-l-4 ${colors[color]} shadow`}>
      <p className="text-sm text-gray-500">{title}</p>
      <p className="text-2xl font-bold mt-1">{value}</p>
      <p className="text-green-500 text-sm mt-1">↑ {growth}</p>
    </div>
  );
}
